import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import { PagerService } from "../../core/services/pager.service";

@Component({
  selector: "app-dailinconference",
  templateUrl: "./dailinconference.component.html",
  styleUrls: ["./dailinconference.component.css"],
})
export class DailinconferenceComponent implements OnInit {
  public successfulData: any = [];
  DeviceTypeList;
  Device;
  Countries;
  existCapNo;
  ErrorMessage;
  DailInConferenceNo;
  DialInConferenceNumber;
  DeviceDetails;
  Facilities: any[];
  LoggedInEnterpriseId;

  public country = "";
  public Type = "";
  public rowsPerPage = 5;
  public LoginEnterpriseID = "";
  public Country = "";
  public DeviceType;
  public Role = "";
  dataLoader: boolean;

  // pager object
  pager: any = {};
  // array of all items to be paged
  private allItems: any[];
  // paged items
  pagedItems: any[];

  constructor(
    private router: Router,
    private capservice: CAPService,
    private _avRoute: ActivatedRoute,
    private pagerService: PagerService
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Role = capservice.Role;
    this.Country = capservice.country;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
      // $location.path("/LoginInvalid");
      // $route.reload();
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {

    this.dataLoader = true;
    this.DeviceDetails = {
      DailInConferenceNumber: "",
      Country: "",
      DeviceType: "",
      EnterpriseID: "",
      strType: "",
      token: "",
      CityName: "",
    };
    this.successfulData = {
      ID1: "",
      Id: "",
      DailInConferenceNumber: "",
      Country: "",
      DeviceType: "",
      EnterpriseID: "",
      strType: "",
      token: "",
      CityName: "",
    };
    this.DeviceTypeList = [
      // { name: 'Skype', },
      { name: "Cisco" },
      { name: "Teams" },
    ];
    this.GetCountryList();
    this.AudiLogin();
    this.ErrorMessage =
      "This section is not enabled. Please contact the Online support or check User Guidelines section for any access or tool issue.";
  }
  GetCountryList() {
    this.capservice.CountryList(this.country, this.Type).subscribe((data) => {
      this.Countries = data;
      this.dataLoader = false;
    });
  }
  // GetFacility(type) {
  //   var country = '';
  //   if (type == 'Edit') {
  //     country = $('#grdCountry').val();
  //   }
  //   else {
  //     country = $('#grdfCCountry').val();
  //   }
  //   this.capservice.FacilityList(country).subscribe(data => {
  //     this.Facilities = data;
  //   })
  // }
  AudiLogin() {
    this.capservice
      .AudiLogin("DailInConferenceCallMapping", this.LoggedInEnterpriseId)
      .subscribe((data) => {});
  }
  validateNumber(e: any) {
    let input = String.fromCharCode(e.charCode);
    const reg = /^[\d ()+-]+$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
  }
  DeviceTypeEvent(event: any) {
    //Paginator.page = 0;
    this.Device = event.target.value;
    if (this.Device == "Teams") {
      $("#AlertForAccess").css("display", "none");

      if (this.Device == "Teams") {
        $("#divCAPMapSearch").css("display", "block");
        $("#divCAPMapSubmit").css("display", "block");
        $("#divCAPMapDetails").css("display", "block");
        this.DailInConferenceNo = "";
        $("#CAPDetailsSkype").css("display", "block");
        $("#CAPDetailsCisco").css("display", "none");
        this.clearCAP();
      } else {
        $("#divCAPMapSearch").css("display", "none");
        $("#divCAPMapSubmit").css("display", "none");
        $("#divCAPMapDetails").css("display", "none");
        this.DailInConferenceNo = "";
        $("#CAPDetailsSkype").css("display", "none");
        $("#CAPDetailsCisco").css("display", "none");
        this.clearCAP();
      }
      // Load Grid Data
      this.InitLoad();
    } else {
      $("#showMsg").css("display", "none");
      $("#AlertForAccess").css("display", "block");
      $("#divCAPMapSearch").css("display", "none");
      $("#divCAPMapSubmit").css("display", "none");
      $("#divCAPMapDetails").css("display", "none");
      $("#CAPDetailsSkype").css("display", "none");
      $("#CAPDetailsCisco").css("display", "none");
    }
  }
  InitLoad() {
    if (this.Device == "Teams") {
      this.capservice
        .SearchDetails(
          "N",
          this.country,
          "N",
          "LoadTeams",
          "DailInConferenceNo"
        )
        .subscribe((data) => {
          if (data.length >= 0) {
            this.dataLoader = true;
            this.successfulData = { capMapDetails: data, selected: {} };
            this.allItems = data;
            // initialize to page 1
            this.setPage(1);
            //  this.existCapNo = data;
            this.dataLoader = false;
          } else {
            alert("No Records Found");
          }
        });
    }
    this.capservice
      .SearchDetails(
        "N",
        this.country,
        "N",
        this.Device,
        "DailInConferenceNoDropdown"
      )
      .subscribe((data) => {
        if (data.length >= 0) {
          this.existCapNo = data; //{ capMapDetails: data, selected: {} }
        }
      });
  }

  ShowData() {
    debugger;
    //Paginator.page = 0;
    var Country = '';
    if (($('#dlstCAPNo')).val() == "" && ($('#dlstCountry')).val() == "") {
      $('#divCAPMapDetails').css("display", 'none');
      alert("Please select value to search");
    }
    else {
      if (this.Device == 'Teams') {
        $('#showMsg').css("display", 'none');
        if (this.Role != 'Global Admin') {
          Country = $('#dlstCountry').val() == '' ? this.Country : $('#dlstCountry').val();
        }
        else {
          Country = $('#dlstCountry').val() == '' ? 'N' : $('#dlstCountry').val();
        }
        var DailInConferenceNo = $('#dlstCAPNo').val() == '' ? 'N' : $('#dlstCAPNo').val();

        // this.capservice.SearchDetails('N', Country, 'N', this.Device, "DailInConferenceNoDropdown").subscribe(data => {
        //   if (data.length >= 0) {
        //     this.existCapNo = data;//{ capMapDetails: d.data, selected: {} }
        //   }
        // });

        if (this.Device == "Teams") {
          this.capservice
            .SearchDetailsTeams(
              "N",
              Country,
              DailInConferenceNo,
              this.Device,
              "DailInConferenceNo"
            )
            .subscribe((data) => {
              if (data.length > 0) {
                this.successfulData = { capMapDetails: data, selected: {} };
                this.allItems = data;
                // initialize to page 1
                this.setPage(1);
                $("#divCAPMapSearch").css("display", "block");
                $("#divCAPMapSubmit").css("display", "block");
                $("#divCAPMapDetails").css("display", "block");
              } else {
                alert("No Records Found");
                $("#divCAPMapDetails").css("display", "none");
                //this.DeviceTypeEvent();
                this.InitLoad();
              }
            });
        } else {
          this.capservice
            .SearchDetails(
              "N",
              Country,
              DailInConferenceNo,
              this.Device,
              "DailInConferenceNo"
            )
            .subscribe((data) => {
              if (data.length > 0) {
                this.successfulData = { capMapDetails: data, selected: {} };
                this.allItems = data;
                // initialize to page 1
                this.setPage(1);
                $("#divCAPMapSearch").css("display", "block");
                $("#divCAPMapSubmit").css("display", "block");
                $("#divCAPMapDetails").css("display", "block");
              } else {
                alert("No Records Found");
                $("#divCAPMapDetails").css("display", "none");
                //this.DeviceTypeEvent();
                this.InitLoad();
              }
            });
        }
      } else {
        $("#showMsg").css("display", "block");
        $("#AlertForAccessdial").css("display", "none");
        $("#divCAPMapSearch").css("display", "none");
        $("#divCAPMapSubmit").css("display", "none");
        $("#divCAPMapDetails").css("display", "none");
      }
    }
  }
  validatePhone(txtPhone) {
    var a = txtPhone;//document.getElementById(txtPhone).value;
    var filter = /^[0-9-+]+$/;
    if (filter.test(a)) { return true; }
    else { return false; }
  }
  AddCAPNo() {
    var message = '';
    var DialNo = $('#grdfCAPNo').val();
    var country = $('#grdfCountry').val();
    if (this.Device == 'Teams') {

      if (this.Device == '') {
        message = "Please Select DeviceType";
      }
      if ($("#grdfCAPNo").val() == "") {
        message =
          message + "\n" + "Please Enter Dial In Conference Call Number";
      }
      if ($("#grdfCountry").val() == "") {
        message = message + "\n" + "Please Select Country";
      }
      if ($("#grdfCityName").val() == "") {
        message = message + "\n" + "Please Enter CityName";
      }
      // if ($('#grdfCAPNo').val() != '') {
      //     if (this.validatePhone('grdfCAPNo')) { }
      //     else { message = message + "\n" + "Please Enter Valid Dial In Conference Number"; }
      // }
    }

    if (message != "") {
      alert(message);
    } else {
      //this.DeviceDetails.DailInConferenceNumber = (MYCASService.encryptedlogin( this.DeviceDetails.DailInConferenceNumber)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.DeviceDetails.Country = (MYCASService.encryptedlogin( this.DeviceDetails.Country)).ciphertext.toString(CryptoJS.enc.Base64);
      this.DeviceDetails.DeviceType = this.Device;
      this.DeviceDetails.EnterpriseID = this.LoginEnterpriseID;
      this.DeviceDetails.strType = "DailInConferenceNo";
      //this.DeviceDetails.token = MYCASService.tokenManager();

      this.capservice
        .InsertVoiceAdminDetails(this.DeviceDetails)
        .subscribe((data) => {
          if (data.toString() == "Inserted Successfully") {
            alert(data);
            //this.DeviceTypeEvent();
            this.InitLoad();
            this.clear();
          } else if (data.toString() == "Failed") {
            alert("Inserted Successfully");
            //this.DeviceTypeEvent();
            this.InitLoad();
            this.clear();
          } else if (data.toString() == "Data already exists") {
            alert(
              "Dial In Conference Call Number : " +
                DialNo +
                "  already exists for Country : " +
                country +
                ""
            );
            //this.DeviceTypeEvent();
            this.InitLoad();
            this.clear();
          }
        });
    }
  }
  EditCAPNo(data) {
    this.successfulData.selected = Object.assign({}, data); //angular.copy(data);
  }
  DeleteCAPNo(data) {
    this.capservice
      .DeleteVoiceAdminDetails(
        data.Id,
        "DailInConferenceNo",
        this.LoginEnterpriseID,
        null
      )
      .subscribe((data) => {
        if (data.toString() == "Failed") {
          alert("Deleted Successfully");
          //this.DeviceTypeEvent();
          this.InitLoad();
          this.clear();
        } else {
          alert(data);
          //this.DeviceTypeEvent();
          this.InitLoad();
          this.clear();
        }
      });
  }
  UpdateCAPNo(data) {
    var message = '';
    var DialNo = $('#grdCAPNo').val();
    var country = $('#grdCountry').val();
    if (this.Device == 'Teams') {

      if (this.Device == '') {
        message = "Please Select DeviceType";
      }
      if ($("#grdCAPNo").val() == "") {
        message =
          message + "\n" + "Please Enter Dial In Conference Call Number";
      }
      if ($("#grdCountry").val() == "") {
        message = message + "\n" + "Please Select Country";
      }
      if ($("#grdCityName").val() == "") {
        message = message + "\n" + "Please Enter CityName";
      }
      // if ($('#grdCAPNo').val() != '') {
      //     if (this.validatePhone('grdCAPNo')) { }
      //     else { message = message + "\n" + "Please Enter Valid Dial In Conference Call Number"; }
      // }
    }

    if (message != "") {
      alert(message);
    } else {
      //this.successfulData.capMapDetails[idx] = angular.copy( this.successfulData.selected);
      this.successfulData.selected.ID1 =
        this.successfulData.selected.Id.toString();
      this.successfulData.selected.Id = this.successfulData.selected.Id;
      //this.successfulData.selected.DailInConferenceNumber = (MYCASService.encryptedlogin( this.successfulData.selected.DailInConferenceNumber)).ciphertext.toString(CryptoJS.enc.Base64);
      //this.successfulData.selected.Country = (MYCASService.encryptedlogin( this.successfulData.selected.Country)).ciphertext.toString(CryptoJS.enc.Base64);
      this.successfulData.selected.DeviceType = this.Device;
      this.successfulData.selected.strType = "DailInConferenceNo";
      this.successfulData.selected.EnterpriseID = this.LoginEnterpriseID;
      //this.successfulData.selected.token = MYCASService.tokenManager();

      this.capservice
        .UpdateVoiceAdminDetails(this.successfulData.selected)
        .subscribe((data) => {
          if (data.toString() == "Updated Successfully") {
            alert(data);
            //this.DeviceTypeEvent();
            this.InitLoad();
            this.clear();
          } else if (data.toString() == "Failed") {
            alert("Updated Successfully");
            this.InitLoad();
            //this.DeviceTypeEvent();
            this.clear();
          } else if (data.toString() == "Data already exists") {
            alert(
              "Dial In Conference Call Number : " +
                DialNo +
                "  already exists for Country : " +
                country +
                " "
            );
            //this.DeviceTypeEvent();
            this.InitLoad();
            this.clear();
          }
        });
    }
  }
  clear() {
    $("#grdfCAPNo").val("");
    $("#grdfCountry").val("");
    $("#grdCAPNo").val("");
    $("#grdCountry").val("");
    $("#dlstCAPNo").val("");
    $("#dlstCountry").val("");
    $("#grdfCFacility").val("");
    $("#grdfCWBSE").val("");
    $("#grdfCDescription").val("");
    $("#grdEFacility").val("");
    $("#grdEWBSE").val("");
    $("#grdEDescription").val("");
    $("#grdECAPNo").val("");
    $("#grdECountry").val("");
    $("#grdfCCAPNo").val("");
    $("#grdfCCountry").val("");
    $("#grdfCityName").val("");
    $("#grdCityName").val("");
    $("#divCAPMapDetails").css("display", "block");
    this.DialInConferenceNumber = "";
    //this.DeviceTypeEvent();
    this.InitLoad();
  }
  clearCAP() {
    $("#dlstCAPNo").val("");
    $("#dlstCountry").val("");
    $("#grdfCAPNo").val("");
    $("#grdfCountry").val("");
    $("#grdCAPNo").val("");
    $("#grdCountry").val("");
    $("#grdfCFacility").val("");
    $("#grdfCWBSE").val("");
    $("#grdfCDescription").val("");
    $("#grdEFacility").val("");
    $("#grdEWBSE").val("");
    $("#grdEDescription").val("");
    $("#grdfCCAPNo").val("");
    $("#grdfCCountry").val("");
    $("#grdfCityName").val("");
    $("#grdCityName").val("");
  }
  reset() {
    this.successfulData.selected = {};
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.capMapDetails = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }
}
